// Wraps a DOM event handler function and calls `preventDefault` on the DOM event.
export function preventDefault(func) {
  return (evt) => {
    evt.preventDefault();
    func(evt);
  };
}
